// Represents a notification for a user inside the notifications tab

import { Expose } from "class-transformer";
import { Event } from "./event";

// Receives the fields from the backend, but some of them are used only on the frontend (i.e. read, for checking if user has seen it already)
export class UserNotificationItem {
  public id: number;
  public subject: string;
  public cc: string;
  public content: string;
  public createdAt: Date;
  public event: Event;
  @Expose({name: 'read'})
  public removed: boolean = false //Tells if the user cleaned this message, if so, it shouldnt be shown on the navbar menu
}
